import { rgba } from 'polished';
import { NavLink } from 'react-router-dom';
import styled, { css } from 'styled-components';
import { variant } from 'styled-system';
import { textStyles } from '../../../theme/config/typography';
import {
  StyledSideMenuLinkProps,
  StyledSideMenuProps,
} from './types';

export const StyledSideMenu = styled.div`
  width: 100%;
`;

export const StyledSideMenuRow = styled.nav`
  width: 100%;
  padding: 0.5rem 0;
  &:not(:last-child) {
    border-bottom: 1px solid ${({ theme }) => theme.colors.navigation.border};
    margin-bottom: 0.5rem;
    padding-bottom: 0.75rem;
  }
`;

export const StyledSideMenuLink = styled(NavLink).attrs({
  variant: 'body',
  activeClassName: 'is-active',
})<StyledSideMenuLinkProps>`
  display: flex;
  align-items: center;
  width: 100%;
  padding: 0.625rem 0.875rem;
  border-radius: 0.5rem;
  text-decoration: none;
  font-size: 0.875rem;
  font-weight: 400;
  letter-spacing: -0.005em;
  color: ${({ theme }) => theme.colors.text.secondary};
  background-color: transparent;
  transition: ${({ theme }) => theme.transitions.default};
  position: relative;
  ${variant({
    variants: {
      ...textStyles,
    },
  })};

  ${({ collapsed }) =>
    collapsed &&
    css`
      justify-content: center;
      padding: 0.625rem 0;
    `}

  &.is-active {
    background-color: ${({ theme }) => rgba(theme.colors.accent, 0.1)};
    color: ${({ theme }) => theme.colors.text.primary};
    font-weight: 600;
  }

  &.is-active svg {
    color: ${({ theme }) => theme.colors.accent};
  }

  &.is-active::before {
    content: '';
    position: absolute;
    ${({ theme }) =>
      theme.direction === 'rtl' ? 'right: -1rem;' : 'left: -1rem;'}
    top: 0.25rem;
    bottom: 0.25rem;
    width: 4px;
    background-color: ${({ theme }) => theme.colors.accent};
    border-radius: 0 3px 3px 0;
    ${({ theme }) =>
      theme.direction === 'rtl' &&
      css`
        border-radius: 3px 0 0 3px;
      `}
  }

  ${({ collapsed }) =>
    collapsed &&
    css`
      &.is-active::before {
        left: -0.5rem;
      }
    `}

  &:hover:not(.is-active) {
    background-color: ${({ theme }) => rgba(theme.colors.accent, 0.05)};
    color: ${({ theme }) => theme.colors.text.primary};
  }
`;

export const StyledSideMenuLabel = styled.span`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const StyledSideMenuList = styled.ul<StyledSideMenuProps>`
  list-style: none;
  padding: 0;
  margin: 0;
  width: 100%;
  ${({ hasMinHeight, theme }) =>
    hasMinHeight &&
    css`
      min-height: ${theme.dimensions.sidebar.list.minHeight};
    `}
`;

export const StyledSideMenuListItem = styled.li`
  width: 100%;
  &:not(:last-child) {
    margin-bottom: 0.125rem;
  }
`;

export const StyledSideMenuIconWrapper = styled.span<StyledSideMenuLinkProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 1.25rem;
  flex-shrink: 0;
  color: inherit;
  opacity: 0.85;

  ${({ theme, collapsed }) =>
    collapsed
      ? css`
          margin: 0;
        `
      : theme.direction === 'rtl'
      ? css`
          margin-left: 0.875rem;
        `
      : css`
          margin-right: 0.875rem;
        `}
  svg {
    height: 1.25rem;
    width: 1.25rem;
    color: currentColor;
  }
`;
